import Relatorio from '@/views/pages/relatorio/Relatorio'
import Inventario from '@/views/pages/relatorio/inventario/RelatorioInventario.vue'
import RelatorioTce from '@/views/pages/relatorio/tce/RelatorioTce.vue'
import RelatorioPersonalizado from '@/views/pages/relatorio/personalizados/RelatorioPersonalizado.vue'

class RelatoriosBuilder {
    build(parametros) {
        const routes = [
            {
                path: '/relatorio',
                name: 'Relatorios',
                component: Relatorio,
                meta: {
                    menu: {
                        title: 'Relatórios ',
                        icon: 'fas fa-file-download'
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Consulta']
                },
                children: [
                    {
                        path: '/inventario',
                        name: 'inventario',
                        component: Inventario,
                        meta: {
                            menu: {
                                title: 'Inventário'
                            },
                            page: {
                                title: 'Relatórios',
                                subtitle: 'Inventário'
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.Consulta']
                        }
                    },
                    {
                        path: '/personalizados',
                        name: 'Personalizados',
                        component: RelatorioPersonalizado,
                        meta: {
                            menu: {
                                title: 'Personalizados'
                            },
                            page: {
                                title: 'Relatórios',
                                subtitle: 'Personalizados'
                            },
                            requiresAuth: true,
                            authorities: ['Patrimonio.RelatorioPersonalizados']
                        }
                    }
                ]
            }
        ]

        if (parametros.cliente === 'ES') {
            routes[0].children.push({
                path: '/tce',
                name: 'tce',
                component: RelatorioTce,
                meta: {
                    menu: {
                        title: 'TCE'
                    },
                    page: {
                        title: 'Relatórios',
                        subtitle: 'TCE'
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Consulta']
                }
            })
        }

        routes[0].children = routes[0].children.sort((a, b) => a.meta.menu.title.localeCompare(b.meta.menu.title))

        return routes
    }
}

export default new RelatoriosBuilder()
